<div class="d-flex justify-content-around">
    <div class="d-flex p-2 align-items-center tab cursor-pointer" [ngClass]="{'tab-selected': tabMultibanco}"
        (click)="tabClick(paymentMethodEnum.MULTIBANCO)">
        <div class="m-auto">
            <img src="assets/images/multibanco-horizontal-logo.svg" alt="MB" class="img-tab" />
        </div>
    </div>
    <div class="d-flex align-items-center tab cursor-pointer" [ngClass]="{'tab-selected': tabOpenBanking}"
        (click)="tabClick(paymentMethodEnum.OPEN_BANKING)" *ngIf="!contract.HasServiceFaturaSegura">
        <div class="d-flex m-auto open-bank-icon">
            <i class="icon-edponline-Bop-020" aria-hidden="true"></i>
            <span class="tab-open-bank">Open Banking</span>
        </div>
    </div>
    <div class="d-flex p-2 align-items-center tab cursor-pointer" [ngClass]="{'tab-selected': tabMbWay}"
        (click)="tabClick(paymentMethodEnum.MB_WAY)" *ngIf="!contract.HasServiceFaturaSegura">
        <div class="m-auto">
            <img src="assets/images/mbway-logo.png" alt="MB Way" class="img-tab" />
        </div>
    </div>
</div>


<div class="payment-tab-content">
    <div class="full-height">

        <!-- Tab Multibanco -->
        <ng-container *ngIf="tabMultibanco">
            <ng-container *ngIf="paymentReference">
                <div class="mb">
                    <span class="date-title">{{ 'pt.edp.edponline.payment.method.date' | translate }}</span>
                    <span class="date">{{ dateLimit | date: 'd MMM y'}}</span>

                    <div>
                        <span class="title">{{ 'pt.edp.edponline.payment.method.mb.entidade' | translate }}</span>
                        <span class="value">{{ paymentReference?.paymentData?.PaymentEntity }}</span>
                    </div>
                    <div>
                        <span class="title">{{ 'pt.edp.edponline.payment.method.mb.referencia' | translate }}</span>
                        <span class="value">{{ paymentReference?.paymentData?.PaymentReference }}</span>
                    </div>
                    <div>
                        <span class="title">{{ 'pt.edp.edponline.payment.method.mb.montante' | translate }}</span>
                        <span class="value">{{ paymentReference?.paymentData?.PaymentValue }}€</span>
                    </div>
                </div>
                <div class="sms d-flex align-items-center cursor-pointer">
                    <a (click)="openGetRefMbModal()" class="mx-auto">
                        <span>{{ 'pt.edp.edponline.payment.method.mb.button' | translate }}</span>
                        <span class="d-inline-block align-middle mx-2">
                            <i class="icon-edponline-Bop-014 icon" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </ng-container>

            <ng-container *ngIf="!paymentReference">
                <div class="payment-reference" [ngClass]="{ 'hide': multibancoLoading }">
                    <span class="description">{{ 'pt.edp.edponline.payment.method.mb.debt.description' | translate
                        }}</span>
                    <button impersonateDisable class="btn btn-primary w-75 button-final align-bottom"
                        (click)="getPaymentReference()">
                        {{ 'pt.edp.edponline.payment.method.mb.debt.button' | translate | edpCapitalize }}
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="multibancoLoading">
                <edp-loader [size]="'md'" [position]="'center'"></edp-loader>
            </ng-container>
        </ng-container>


        <!-- Tab MB Way-->
        <ng-container *ngIf="tabMbWay">
            <div class="mb-way" *ngIf="!mbwayLoading">
                <ng-container *ngIf="!debt">
                    <span class="date-title">{{ 'pt.edp.edponline.payment.method.date' | translate }}</span>
                    <span class="date">{{ dateLimit | date: 'd MMM y'}}</span>
                </ng-container>
                <span class="description"
                    [innerHTML]="'pt.edp.edponline.payment.method.mbway.description' | translate | edpCapitalize">
                </span>
                <form [formGroup]="form" class="p-0">
                    <div class="form input-container fluid">
                        <div class="d-inline-flex w-100">
                            <label>{{ 'pt.edp.edponline.payment.method.mbway.phone' | translate | edpCapitalize
                                }}</label>
                        </div>
                        <input type="number" class="form-control" formControlName="phoneNumber">
                        <span class="error input-error" [ngClass]="{ 'show': showPhoneError }">
                            {{ 'pt.edp.edponline.mbway.input.error' | translate | edpCapitalize }}
                        </span>
                    </div>
                    <button impersonateDisable class="btn btn-primary w-100 button-final align-bottom" type="button"
                        (click)="mbwaySubmit()" [ngClass]="{'disabled': isSubmitted}">
                        {{ 'pt.edp.edponline.payment.method.mbway.button' | translate | edpCapitalize }}
                    </button>
                </form>
            </div>
            <div class="d-flex flex-column h-100" *ngIf="mbwayLoading">
                <edp-loader [size]="'md'" class="text-center mh-loader"></edp-loader>
                <div class="simulation-load-message text-center">
                    {{ 'pt.edp.edponline.payments.invoices.processing.payment' | translate | edpCapitalize }}
                </div>
            </div>
        </ng-container>


        <!-- Tab Open Banking-->
        <ng-container *ngIf="tabOpenBanking">
            <div class="open-banking" *ngIf="!openBankingLoading">
                <ng-container *ngIf="bankListSelected.length > 0">
                    <span class="bank-date-title">{{ 'pt.edp.edponline.open.banking.limit.date' | translate |
                        edpCapitalize }}</span>
                    <span class="bank-date">{{ dateLimit | date: 'd MMM y'}}</span>
                </ng-container>
                <ng-container *ngIf="bankListSelected.length <= 0">
                    <span class="description">{{ 'pt.edp.edponline.open.banking.description' | translate | edpCapitalize
                        }}
                        <a href="{{ 'pt.edp.edponline.open.banking.link.url' | translate }}" target="_blank"
                            rel="noopener noreferrer" class="more">{{ 'pt.edp.edponline.open.banking.link' | translate
                            }}</a>
                    </span>
                </ng-container>
                <div *ngIf="bankListSelected.length > 0">
                    <span class="title" [ngClass]="{'invisible': canManageBank}">{{
                        'pt.edp.edponline.open.banking.bank.title' | translate | edpCapitalize }}</span>
                    <ng-container *ngIf="!canManageBank">
                        <span class="bank-gestion cursor-pointer" (click)="manageBank(true)">
                            {{ 'pt.edp.edponline.open.banking.manage.banks' | translate | edpCapitalize }}
                            <i class="icon-edponline-Bop-022" aria-hidden="true"></i>
                        </span>
                    </ng-container>
                    <span class="bank-gestion cursor-pointer" *ngIf="canManageBank" (click)="manageBank(false)">
                        {{ 'pt.edp.edponline.open.banking.manage.banks.close' | translate | edpCapitalize }}
                        <i class="icon-edponline-Bop-071" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="bank-zone">
                    <ng-container *ngFor="let bank of bankListSelected; index as i">
                        <div class="bank-added d-flex align-items-center cursor-pointer"
                            [ngClass]="{'selected': (bank === bankSelected) || (bankListSelected.length < 2)}"
                            (click)="bankSelection(bank)">
                            <span class="name">{{ bank.institution_name | truncate }}</span>
                            <i class="icon-edponline-Bop-068 icon-delete ml-auto cursor-pointer" *ngIf="canManageBank"
                                (click)="deleteBank(i)" aria-hidden="true"></i>
                        </div>
                    </ng-container>
                    <ng-container
                        *ngIf="(bankListSelected.length <= 0 || canManageBank) && bankListSelected.length < 2">
                        <div class="add-bank d-flex align-items-center cursor-pointer" (click)="addBank()">
                            <i class="icon-edponline-Bop-074 icon-bank" aria-hidden="true"></i>
                            <span>{{ 'pt.edp.edponline.open.banking.add.bank' | translate }}</span>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="!canManageBank">
                    <span class="warning" *ngIf="bankListSelected.length > 0"
                        [innerHTML]="'pt.edp.edponline.open.banking.warning' | translate | edpCapitalize"></span>
                    <button impersonateDisable class="btn btn-primary w-75 button-final align-bottom"
                        [disabled]="!bankSelected" [ngClass]="{'disabled': !bankSelected}"
                        (click)="openBankingSubmit()">
                        {{'pt.edp.edponline.open.banking.confirm' | translate | edpCapitalize }}
                    </button>
                </ng-container>
            </div>

            <div class="d-flex flex-column h-100" *ngIf="openBankingLoading">
                <edp-loader [size]="'md'" class="text-center mh-loader"></edp-loader>
                <div class="simulation-load-message text-center">
                    {{ 'pt.edp.edponline.payments.invoices.processing.payment' | translate | edpCapitalize }}
                </div>
            </div>
        </ng-container>

    </div>
</div>
